'use client';

import { useEffect, useState } from 'react';

export default function CursorGlow() {
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            setPosition({ x: e.clientX, y: e.clientY });
            setIsVisible(true);
        };

        const handleMouseLeave = () => {
            setIsVisible(false);
        };

        window.addEventListener('mousemove', handleMouseMove);
        document.body.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            document.body.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);

    return (
        <div
            className="pointer-events-none fixed inset-0 z-30 transition-opacity duration-300"
            style={{ opacity: isVisible ? 1 : 0 }}
            aria-hidden="true"
        >
            <div
                className="absolute w-[500px] h-[500px] rounded-full blur-[100px] transition-transform duration-75"
                style={{
                    background: 'radial-gradient(circle, color-mix(in srgb, var(--color-md-primary) 8%, transparent) 0%, transparent 70%)',
                    left: position.x - 250,
                    top: position.y - 250,
                }}
            />
        </div>
    );
}
